import { LecturerRateDisplayType } from '../../../api/types/lecturers/price-rate/lecturer-rate-display-type';
import { RequestRateStatus } from '../../../api/types/lecturers/price-rate/request-rate/request-rate-status';
import { UserSummaryType } from '../../../api/types/user/user-summary.type';

export interface RatesReportFilterType {
  branchIds: number[];
  professors: UserSummaryType[];
  rateMin: number | null;
  rateMax: number | null;
  travelRateMin: number | null;
  travelRateMax: number | null;
  includeNoTravelRate: boolean;
  displayTypes: LecturerRateDisplayType[];
  validityStart: Date | null;
  validityEnd: Date | null;
  requestStatuses: RequestRateStatus[];
}

export const defaultRatesReportFilter = (): RatesReportFilterType => ({
  branchIds: [],
  professors: [],
  rateMin: null,
  rateMax: null,
  travelRateMin: null,
  travelRateMax: null,
  includeNoTravelRate: false,
  displayTypes: [],
  validityStart: null,
  validityEnd: null,
  requestStatuses: [],
});
